export const Panel = ({ title, subtitle, action, className = "", children, testId }) => (
  <section
    data-testid={testId}
    className={`rounded-lg bg-[#131f37] border border-[#1e293b] hover:border-slate-700/80 transition-colors shadow-[0_4px_24px_-4px_rgba(10,20,37,0.7)] ${className}`}
  >
    {(title || action) && (
      <header className="flex items-start justify-between gap-4 px-5 sm:px-6 pt-5">
        <div className="min-w-0">
          <h3 className="font-heading text-base font-semibold text-slate-100">{title}</h3>
          {subtitle && <p className="mt-1 text-xs text-slate-400">{subtitle}</p>}
        </div>
        {action}
      </header>
    )}
    <div className="p-5 sm:p-6">{children}</div>
  </section>
);
